import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from './auth.service';
import {map, tap} from 'rxjs/operators';
import {AuthState} from './auth-state.enum';

/**
 * It only lets you in if you're unlogged
 */
export const loggedOutGuard: CanActivateFn = (route, state) => {
  const auth: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  return auth.getActualState().pipe(
    map(state => {
      return state === AuthState.LOGGED_OUT ? true : router.createUrlTree(['/']);
    }),
  );
};
